module.exports = __webpack_public_path__ + "img/電気回路_3_8_2.67ac988e.png";